import { Button, Link, Text } from '@postenbring/hedwig-react';
import './campaign-page-text-field.scss';

export const CampaignTextField = ({ text, cta }) => (
    <div style={{ textAlign: text.align }} className="hds-mb-20-24 bring-campaign-page-text-field">
        <Text variant={text.heading.tag} className='hds-mb-20-24'>{text.heading.content}</Text>
        {text.htmlArea && <div className="hds-mb-20-24" dangerouslySetInnerHTML={{ __html: text.htmlArea }}></div>}
        {cta &&
            <div>
                {cta.type === 'primary-button' &&
                    <Button variant="primary" asChild>
                        <a href={cta.href} target={cta.newTab}>{cta.text}</a>
                    </Button>
                }
                {cta.type === 'secondary-button' &&
                    <Button variant="secondary" asChild>
                        <a href={cta.href} target={cta.newTab}>{cta.text}</a>
                    </Button>
                }
                {cta.type === 'link' &&
                    <Link href={cta.href} target={cta.newTab}>{cta.text}</Link>
                }
            </div>
        }

    </div>
)